export const translationReactNetworkNamespace = 'translationReactNetwork';
